export const TEMP_USER_ROLE_KEY = 'temp_userrole'
